/** Hulpjes om te zien of de browser het beeld echt toont (4K/HEVC kan zwart blijven terwijl het geluid speelt). */

export function hevcSupported(): boolean {
  try {
    const ms = (window as unknown as { MediaSource?: typeof MediaSource }).MediaSource;
    if (!ms) return false;
    return ms.isTypeSupported('video/mp4; codecs="hvc1.2.4.L153.B0"') || ms.isTypeSupported('video/mp4; codecs="hev1.2.4.L153.B0"');
  } catch {
    return false;
  }
}

/**
 * Roept onNoVideo aan als er na een paar seconden afspelen nog geen enkel beeldje is getoond.
 * Geeft een functie terug om te stoppen met kijken.
 */
export function watchForBlackVideo(el: HTMLVideoElement, onNoVideo: () => void, afterSec = 6): () => void {
  let timer: number | undefined;
  let fired = false;
  const check = () => {
    if (fired || el.paused || el.readyState < 2) return;
    const frames = el.getVideoPlaybackQuality?.().totalVideoFrames;
    const noFrames = frames !== undefined ? frames === 0 : false;
    if (el.videoWidth === 0 || noFrames) {
      fired = true;
      onNoVideo();
    }
  };
  const onPlaying = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(check, afterSec * 1000);
  };
  el.addEventListener('playing', onPlaying);
  return () => {
    window.clearTimeout(timer);
    el.removeEventListener('playing', onPlaying);
  };
}
